import { HttpMethod } from 'app/utils/network';
import { API } from 'app/utils/request';

export const addService = (serviceRequest, authToken) => {
  const urlPath = '/service/addService';
  const additionalHeader = {Authorization: `Bearer ${authToken}`}
  return API.request({
    method: HttpMethod.POST,
    urlPath: urlPath,
    body: serviceRequest,
    additionalHeader: additionalHeader
  });
};

export const updateService = (serviceRequest, authToken) => {
  const urlPath = '/service/updateService';
  const additionalHeader = {Authorization: `Bearer ${authToken}`}
  return API.request({
    method: HttpMethod.POST,
    urlPath: urlPath,
    body: serviceRequest,
    additionalHeader: additionalHeader
  });
};

export const getServiceById = (refDoctorId, authToken) => {
  const urlPath = `/service/getServiceByRefDoctorId/${refDoctorId}`;
  const additionalHeader = {Authorization: `Bearer ${authToken}`}
  return API.request({
    method: HttpMethod.GET,
    urlPath: urlPath,
    additionalHeader: additionalHeader
  });
};

export const removeServiceById = (serviceID, authToken) => {
  const urlPath = `/service/removeService/${serviceID}`;
  const additionalHeader = {Authorization: `Bearer ${authToken}`}
  return API.request({
    method: HttpMethod.DELETE,
    urlPath: urlPath
  });
};